import { openBlock as l, createElementBlock as t, createElementVNode as r } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return l(), t("svg", o, [...e[0] || (e[0] = [
    r("g", { "clip-path": "url(#a)" }, [
      r("path", {
        fill: "currentColor",
        d: "M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996 0 0 0 0-1.41L9.15 2.98a1.25 1.25 0 0 0-1.77 0 1.25 1.25 0 0 0 0 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76"
      })
    ], -1),
    r("defs", null, [
      r("clipPath", { id: "a" }, [
        r("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
